// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__FZP5p","content":"ManualTimeModal_content__1W7Ez"};